import { useLayoutEffect, useRef } from "react";

export const ScrollToTop = () => {
  const scrollTopRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (scrollTopRef.current) {
      scrollTopRef.current.scrollIntoView({ block: "center" });
    }
  }, []);

  return <div ref={scrollTopRef} />;
};
